import wordingModules from 'src/store/modules/wording'
import generalModules from 'src/store/general'
import endpoint from 'src/store/modules/endpoint'
import {
  commonDate,
  dateTime
} from 'src/helpers'

const { lang } = generalModules.state()
const wording = wordingModules.state

export const doMainTable = {
  api: endpoint.state.do,
  exportApi: endpoint.state.do,
  columns: [
    {
      name: 'do_no',
      label: 'Nomor Delivery Order',
      align: 'left',
      field: row => {
        const goodsHandover = row.goodsHandover
          ? `<div class="text-grey-7">${row?.goodsHandover}</div>`
          : ''
        return `
          <div>
            <strong
              router-push="${
                encodeURIComponent(
                  JSON.stringify({
                    name: 'do-detail',
                    params: {
                      id: row.id,
                      name: row.do_no
                    }
                  })
                )
              }"
            >${row.do_no}</strong>
            ${
              row.alert && !!row.alert
              ? ` <img
                src="${require('src/assets/images/icons/16x16-yellow-alert.svg')}"
                class="color-blue"
                alt="icon"
              >`
              : ''
            }
          </div>
          ${goodsHandover}
        `
      },
      sortable: true,
      rowClass: 'text-no-wrap'
    },
    {
      name: 'po_no',
      label: 'Nomor Purchase Order',
      align: 'left',
      field: row => {
        const companyName = `
          <div class="text-grey-7">
            ${row.supplier_name || ''}
          </div>`

        return `
          <div>
            <strong
              router-push="${
                encodeURIComponent(
                  JSON.stringify({
                    name: 'po-detail',
                    params: {
                      id: row.po_id,
                      name: row.po_no
                    }
                  })
                )
              }"
            >${row.po_no}</strong>
          </div>
          ${companyName}
        `
      },
      sortable: true,
      rowClass: 'text-no-wrap'
    },
    {
      name: 'so_no',
      label: 'Nomor Sales Order',
      align: 'left',
      field: row => {
        return `
          <div>
            <strong
              router-push="${
                encodeURIComponent(
                  JSON.stringify({
                    name: 'so-detail',
                    params: {
                      id: row.so_id,
                      name: row.so_no
                    }
                  })
                )
              }"
            >${row.so_no}</strong>
          </div>
        `
      },
      sortable: true,
      rowClass: 'text-no-wrap'
    },
    {
      name: 'customer_name',
      label: 'Customer',
      align: 'left',
      field: row => {
        return `
        <div class="text-weight-bold">${row.customer_name}</div>
        ${(row.company_name
          ? `<div>${row.company_type || ''} ${row.company_name}</div>`
          : '')}
        `
      },
      rowClass: 'td-width-medium text-capitalize'
    },
    {
      label: 'Jenis Pembayaran',
      name: 'bnpl_name',
      field: (row) => {
        const paymentType = {
          'MODAL RAKYAT': 'Modal Rakyat',
          'JM TEMPO': 'JM Tempo',
          'JM PAYLATER': 'JM Paylater',
          PAPER: 'Paper.id',
          KOINWORKS: 'Koinworks',
          CREDILINQ: 'Credilinq.ai'
        }[row.bnpl_name] || 'Tunai'

        const image = row.bnpl_name
          ? row.image_payment
          : require('src/assets/images/icons/24x24-tunai-circle.png')

        return `<div class="flex no-wrap items-center gap-2">
          <img
            src="${image}"
            alt="${row.payment_type}"
            class="payment-type-img"
          >
          <div class="flex column text-no-wrap">
            <strong>${paymentType}</strong>
            <span class="text-grey-7">
              ${
                row.bnpl_name
                  ? row.top_day + ' Hari'
                  : 'Transfer Manual'
              }
            </span>
          </div>
        </div>`
      },
      align: 'left'
    },
    {
      name: 'district',
      label: 'Kecamatan Tujuan',
      align: 'left',
      field: row => {
        return `
        <div class="text-weight-bold">${row.district}</div>
        `
      },
      rowClass: 'td-width-small text-capitalize'
    },
    {
      name: 'product',
      label: 'Jumlah Barang',
      align: 'left',
      field: row => {
        const { product } = row
        const hasItem = product.length > 0
        const qty = `+${product.length - 1} Lainnya`
        return hasItem
          ? `
            <div class="column text-left">
              <p class="q-mb-xs">${product[0]?.product_name}</p>
              <p
                class="no-margin ${product.length <= 1 && 'hidden'}" style="font-size: 10px"
              >
                ${qty}
              </p>
            </div>
          `
          : '-'
      },
      rowClass: 'td-width-small'
    },
    {
      name: 'shipping_at',
      label: 'Est. Pengiriman',
      field: row => {
        return row.shipping_at && !!row.shipping_at
          ? `<div class="flex column">
              <span>
                ${
                  commonDate({
                    date: row.shipping_at,
                    useDayName: true
                  })
                }
              </span>
            </div>`
          : '-'
      },
      align: 'left',
      rowClass: 'text-no-wrap'
    },
    {
      name: 'delivery_at',
      label: 'Tgl. Barang Terkirim',
      align: 'left',
      field: row => (
        row.delivery_at && !!row.delivery_at
          ? `<div class="flex column">
              <span>
                ${
                  commonDate({
                    date: row.delivery_at,
                    useDayName: true
                  })
                }
              </span>
              <span class="text-grey-7">
                ${dateTime(row.delivery_at)}
              </span>
            </div>`
          : '-'
      ),
      rowClass: 'text-no-wrap'
    },
    {
      name: 'return_letter_at',
      label: 'Tgl. Surat Jalan Balik',
      align: 'left',
      field: row => (
        row.return_letter_at && !!row.return_letter_at
          ? `<div class="flex column">
              <span>
                ${
                  commonDate({
                    date: row.return_letter_at,
                    useDayName: true
                  })
                }
              </span>
              <span class="text-grey-7">
                ${dateTime(row.return_letter_at)}
              </span>
            </div>`
          : '-'
      ),
      rowClass: 'text-no-wrap'
    },
    {
      name: 'status',
      label: 'Status Pemesanan',
      align: 'left',
      field: 'status',
      format: val => {
        const status = wording[lang].doStatus[val]
        if (val && status) {
          const badgeClass = val !== 'CANCELED' ? 'green' : 'red'
          return `
            <div role="alert" class="custom-badge custom-badge-${badgeClass}">
              ${status}
            </div>
          `
        }

        return '-'
      }
    }
  ]
}
